import React, { Component } from "react"
import "./AuthHomePageContent.scss"
import { Query } from "react-apollo"
import GET_HOME_PAGE_CONTENT from "../../graphql/getHomePageContent.graphql"
import moment from "moment"
import Loading from "../Loading"
import DashboardFavorites from "../DashboardFavorites"
import ContentCard, { CardTitle } from "../ContentCard"
import { HomePageCard, EtrInsights } from "./displays"

class AuthHomePageContent extends Component {
  componentDidMount = () => {
    this.props.trackPage("Home", {
      authenticated: true,
    })
  }

  isViewerCIO = () => {
    const roles = this.props.viewer.roles.map((role) => role.toLowerCase())
    const isCIO = roles.some((role) => role === "cio")

    return isCIO
  }

  render() {
    const data = this.props.components
    let { upcomingVenn, pastVenn } = this.props
    return (
      <div className="private-page">
        <div className="home-page-content-container">
          <div className="home-page-container-left">
            <DashboardFavorites trackEvent={this.props.trackEvent} />
            <ContentTop data={data[0]} trackEvent={this.props.trackEvent} />
          </div>
          <div className="home-page-container-right">
            <EtrInsights upcoming={upcomingVenn} past={pastVenn} />
          </div>
        </div>
      </div>
    )
  }
}

const ContentTop = (props) => {
  return (
    <ContentCard>
      <CardTitle title={props.data.title.toUpperCase()} />

      {props.data.components.map((component, idx) => (
        <HomePageList
          data={component}
          section={{ title: props.data.title }}
          key={idx}
          trackEvent={props.trackEvent}
        />
      ))}
    </ContentCard>
  )
}

const HomePageList = (props) => {
  let components
  switch (props.data.class) {
    case "four-x-two-list":
      components = props.data.components.slice(0, 8)
      break
    case "four-x-one-list":
      components = props.data.components.slice(0, 4)
      break
    case "two-x-two-list":
      components = props.data.components.slice(0, 4)
      break
    case "two-x-three-list":
      components = props.data.components.slice(0, 6)
      break
    default:
      components = []
  }
  let section = props.section
  section.innerTitle = props.data.title

  return (
    <div className="list-container">
      {props.data.title !== "" ? (
        <h3 className="home-page-list-title">
          {props.data.title}
          {props.data.subtitle !== "" ? (
            <span className="home-page-list-subtitle">
              {props.data.subtitle}
            </span>
          ) : null}
        </h3>
      ) : null}
      <div className={props.data.class}>
        {components.map((comp, idx) => {
          return (
            <HomePageCard
              data={comp}
              section={section}
              key={idx}
              trackEvent={props.trackEvent}
            />
          )
        })}
        <div className="forward-button"></div>
      </div>
    </div>
  )
}

const AuthHomePageContentWithData = (componentProps) => {
  return (
    <Query
      query={GET_HOME_PAGE_CONTENT}
      variables={{
        upcomingEvents: moment().format(),
        pastEvents: moment().format(),
      }}
    >
      {({ loading, error, data }) => {
        if (loading) return <Loading />
        if (error) {
          console.log("graphql error")
          return null
        }
        return <AuthHomePageContent {...data} {...componentProps} />
      }}
    </Query>
  )
}

export default AuthHomePageContentWithData
